import { connect } from 'react-redux'

import { setCurrentMobileFilter } from '../../../actions'
import { FilterRoute } from './FilterRoute'

const mapStateToProps = (state, ownProps) => ({
  ...ownProps
})

const mapDispatchToProps = {
  setCurrentMobileFilter
}

const FilterRouteContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(FilterRoute)

export { FilterRouteContainer }
